var map = {
	"./2021_KIEE_Award.png": 5343,
	"./IEEE_diploma.png": 2116,
	"./ai_blue.png": 686,
	"./android.png": 8942,
	"./backend_blue.png": 9996,
	"./favicon.png": 5963,
	"./frontend_blue.png": 4056,
	"./header.png": 1972,
	"./junction2020.jpg": 6471,
	"./junction2021.jpg": 2634,
	"./ml-lab.png": 4138,
	"./preview.jpg": 9319,
	"./smartchange.png": 2904,
	"./smartmonitor.png": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;